import Vue from 'vue'
import Nprogress from 'nprogress'
import api from '../../../api/apibackend'
import {
  SET_EXTRAS,
  FETCH_START,
  FETCH_END,
} from './mutations.type'
import {
  GET_EXTRAS,
  CREATE_EXTRA,
  UPDATE_EXTRA,
  DELETE_EXTRA
} from './actions.type'
import { GET_CATALOGUES } from '../catalogues/actions.type'
import { GET_STORE_USER_AUTH } from '../storeModule/actions.type'

const state = {
  extras: [],
  loadingExtras: false,
}

const getters = {
  extras: state => state.extras,
  loadingExtras: state => state.loadingExtras,
}

const mutations = {
  [SET_EXTRAS](state, extras) {
    state.extras = extras
  },
  [FETCH_START](state) {
    Nprogress.start()
    state.loadingExtras = true
  },
  [FETCH_END](state) {
    Nprogress.done()
    state.loadingExtras = false
  },
}

const actions = {
  async [GET_EXTRAS]({ commit, dispatch, rootGetters }) {
    try {
      commit(FETCH_START)
      if (!rootGetters.store) {
        await dispatch(GET_STORE_USER_AUTH)
      }
      await dispatch(GET_CATALOGUES)
      const res = await api.get(`store/${rootGetters.store.id}/extras`)
      const extras = res.data

      extras.forEach(extra => {
        const catalogueResult = rootGetters.catalogues.find(catalogue => {
          return catalogue.id === extra.catalogue_id
        })
        extra.catalogueName = catalogueResult.name
      })
      commit(SET_EXTRAS, extras)
      commit(FETCH_END)
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [CREATE_EXTRA]({ dispatch, commit }, extra) {
    try {
      commit(FETCH_START)
      const { data } = await api.post(`catalogues/${extra.catalogue_id}/extras`, extra)

      await dispatch(GET_EXTRAS)

      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Extra agregado exitosamente'
      })
      commit(FETCH_END)
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al agregar el extra'
      })
    }
  },
  async [UPDATE_EXTRA]({ dispatch, commit }, extra) {
    try {
      commit(FETCH_START)
      const res = await api.patch(`extras/${extra.id}`, extra)
      await dispatch(GET_EXTRAS)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Extra actualizado exitosamente'
      })
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al modificar el extra'
      })
    }
  },
  async [DELETE_EXTRA]({ dispatch, commit }, extraId) {
    try {
      commit(FETCH_START)
      const res = await api.delete(`extras/${extraId}`)
      await dispatch(GET_EXTRAS)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Extra eliminado exitosamente'
      })
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al eliminar el extra'
      })
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
